import React from "react";

import TopNav from "containers/navs/Topnav";

const AppLayout = ({ children }) => {
  return (
    <div id="app-container">
      <TopNav />
      <main>
        <div className="container-fluid">{children}</div>
      </main>
    </div>
  );
};

export default AppLayout;
